import { Component, Input, OnInit } from '@angular/core';
import { AccessPoint } from '../../model/access-point.model';
import { Authorization } from '../../model/authorization';
import { AuthRoles_PTBR } from '../../model/AuthRoles';
import { User } from '../../model/user';
import { UserService } from '../../service/user.service';
import { VehicleAccessEventService } from '../../service/vehicle-access-event.service';
import { PopupImageComponent } from '../popup-image/popup-image.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NbIconModule } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { Essentials } from '../../util/essentials';


@Component({
  selector: 'vehicles-card-slim',
  templateUrl: './vehicles-card-slim.component.html',
  styleUrls: ['./vehicles-card-slim.component.css']
})
export class VehiclesCardSlimComponent implements OnInit {
  public defaultPictureCar: string;

  constructor(private modalservice: BsModalService, private translate: TranslateService, private essentials: Essentials,) {
    this.defaultPictureCar =  essentials.getDefaultCar();
  }

  modalRef: BsModalRef;

  @Input() access: {
    accessAreaId: string,
    accessDirection: string,
    accessDirectionAsString: string,
    accessPointId: string,
    authorizationId: string,
    id: string,
    moment: string,
    plateId: string,
    photo: string,
    photoLicense: string,
    blocked: boolean,
    userName: string,
    description: string;
    rfId: string;
    remoteControl: string;
    role: string;
  };

  ngOnInit(): void {
    // formata a data-hora para ficar mais legivel
    this.access.moment = `${this.access.moment.substr(8,2)}/${this.access.moment.substr(5,2)} - ${this.access.moment.substr(11,8)}`
  }

  showImage() {
    if (this.access.photoLicense != undefined && this.access.photoLicense != "") {
      this.modalRef = this.modalservice.show(PopupImageComponent, Object.assign({}, { class: 'gray modal-md modal-dialog-centered' }));
      this.modalRef.content.photo = this.access.photo;
      this.modalRef.content.hasPhoto2 = true;
      this.modalRef.content.photo2 = this.access.photoLicense;
      this.modalRef.content.userName = this.access.userName;
      this.modalRef.content.accessPoint = this.access.description;
      this.modalRef.content.moment = this.access.moment;
    }
  }
}
